import { useState, useEffect, useCallback, useContext } from 'react';
import axios from 'axios';
import { IFetchReportListParams, IFetchReportListResult } from './reportTypes';
import { ReportContext } from '../../context/ReportProvider';

export function useFetchReportList<T>({ apiUrl, reportId, type, body }: IFetchReportListParams): IFetchReportListResult<T> {
    const [reportList, setReportList] = useState<T[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const reportContext = useContext(ReportContext);

    const fetchData = useCallback(async () => {
        setLoading(true);

        if (apiUrl && reportId) {
            try {
                if (type === 'favorite') {
                    const response = await axios.get<{ reports: T[] }>(apiUrl);
                    setReportList(response.data.reports);
                    reportContext?.setIsPinReport(response.data.reports.some((r: any) => r.reportID === reportId));
                }
                if (type === 'memorized') {
                    const response = await axios.post<{ reports: T[] }>(apiUrl, body);
                    setReportList(response.data.reports);
                }
            } catch (err: any) {
                console.error(`FetchReportList error: ${err.message}`);
                setError('An error occurred while fetching reports. Please try again later.');
            } finally {
                setLoading(false);
            }
        }
        else {
            setError('FetchReportList error: empty userId, holderId or reportId provided!');
        }

    }, [apiUrl]);

    useEffect(() => {
        fetchData();
    }, [
        fetchData,
        reportContext?.memorizedListUpdates,
        reportContext?.favoriteListUpdates
    ]);

    return { reportList, loading, error };
}
